module.exports = __webpack_public_path__ + "static/media/atypical-pattern-2.fe277df0.webm";